export enum Ccm19EmbeddingName {
  ADCELL = "ADCELL",
  CCM19 = "Cookie Consent Manager CCM19",
  Crisp = "Crisp Chatbox",
  Elvent = "Elvent",
  FirstPromoter = "First Promoter",
  FraudBlocker = "Fraud Blocker",
  GoogleAdsConversion = "Google Ads Conversion Tracking",
  GoogleAdsRemarketing = "Google Ads Remarketing",
  GoogleAnalytics = "Google Analytics 4",
  Klar = "Klar",
  Klaviyo = "Klaviyo",
  MetaPixel = "Meta Pixel",
  Posthog = "Posthog",
  ReviewsIo = "Reviews.io",
  Session = "Verwaltung der Session",
  Sovendus = "Sovendus",
  TrustedShops = "Trusted Shops",
  Typeform = "Typeform",
  WooCommerce = "WooCommerce",
  YouTube = "YouTube Video",
}

export const ccm19MinimumConsent: { [key in Ccm19EmbeddingName]?: boolean } = {
  [Ccm19EmbeddingName.CCM19]: true,
  [Ccm19EmbeddingName.Elvent]: true,
  [Ccm19EmbeddingName.Session]: true,
  [Ccm19EmbeddingName.WooCommerce]: true,

  // Enable if the Crisp chatbox is used.
  // [Ccm19EmbeddingName.Crisp]: true,
}
